import React from "react";
import { Route, Navigate } from "react-router-dom";
import { NotFound } from "../shell";

/** defaultRoutes — order preserved for React Router first-match. */
export function defaultRoutes(): React.ReactNode {
  return (
    <>
      {/* ── 6. Defaults & 404 ──────────────────────────────────────────── */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Navigate to="/dashboard" replace />} />

      {/* Catch all - 404 */}
      <Route path="*" element={<NotFound />} />
    </>
  );
}
